import {makeStyles, Theme} from '@material-ui/core';
import {BoxProps} from '@material-ui/core/Box/Box';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  containerScrollable: {
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  container: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    // alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: 'max-content',
      justifyContent: 'flex-start',
      columnGap: '16px',
    },
  }
}));

const Scrollable = (
  {children, className, ...rest}: BoxProps
) => {
  const classes = useStyles();

  return (
    <div className={[classes.containerScrollable, className].filter(Boolean).join(' ')} {...rest}>
      <div className={classes.container}>
        {children}
      </div>
    </div>
  );
};

export default Scrollable;
